export enum OfferStatus {
  OPEN = 'OPEN',
  ACCEPTED = 'ACCEPTED',
  REVOKED = 'REVOKED'
}
